<script setup lang="ts">
import './assets/style.scss'
import { computed } from 'vue'
import { VIcons } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'

const full = defineModel()
const { trs } = useTranslate()

const tooltipText = computed(() =>
  full.value ? trs('itf.map_action_exit_fullscreen') : trs('itf.map_action_fullscreen'),
)

/**
 * Обработка события клика
 */
const clickHandler = () => {
  full.value = !full.value
}
</script>

<template>
  <div class="v-map-full__wrapper">
    <VTooltip location="left" :open-delay="500" :text="tooltipText">
      <template #activator="{ props }">
        <VBtn class="v-map-full__btn" v-bind="props" @click="clickHandler">
          <VIcons :type="full ? 'close_fullscreen' : 'open_in_full'" />
        </VBtn>
      </template>
    </VTooltip>
  </div>
</template>
